import React from 'react';
import { Link } from 'react-router-dom';

const SupportPage = () => {
  return (
    <main className="App-main contact-page">
      <h2>Support</h2>
      <p className="contact-intro">
        For questions about screening results, tenant disputes, or account support, reach us anytime.
      </p>
      <div className="card" style={{ padding: '1.5rem', maxWidth: '560px', margin: '0 auto' }}>
        <h3 style={{ marginTop: 0 }}>Consumer Support</h3>
        <p className="status-text" style={{ marginBottom: '0.75rem' }}>
          Phone: <a href="tel:+12892169928">(289) 216-9928</a>
        </p>
        <p className="status-text" style={{ marginBottom: '0.75rem' }}>
          Email: <a href="mailto:support@rentual.co">support@rentual.co</a>
        </p>
        <p className="status-text">
          Prefer email? Use the <Link to="/contact">contact form</Link> and we’ll get back to you shortly.
        </p>
      </div>
    </main>
  );
};

export default SupportPage;
